<template>
  <div id="compreSportsMeet_scheduleDetail_eventDataAnalysis">
    <MoreThemeList
      v-if="findAnalysisItemParams"
      :axiosBaseUrl="axiosBaseUrl"
      :currThemeObj="currThemeObj"
      :currCid="currCid"
      :currSid="currSid"
      :findAnalysisItemParams="findAnalysisItemParams"
      :paramsChangeObj="paramsChangeObj"
      :curTimeZoneItem="curTimeZoneItem"
    ></MoreThemeList>
  </div>
</template>

<script>
import MoreThemeList from '@components/base/theme/more_themeList.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'compreSportsMeet_scheduleDetail_eventDataAnalysis',
  mixins: [cup_base_data_mixin],
  components: {
    MoreThemeList,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  watch: {
    currSportsDetail: {
      handler(newVal, oldVal) {
        // console.debug('重新刷新数据1:', newVal, oldVal)
        if (
          JSON.stringify(newVal) != JSON.stringify(oldVal) &&
          newVal.eventId
        ) {
          this.init()
        }
      },
      // immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      // 以下三个是主题固定参数（前2个必有，paramsChangeObj可选）
      themeTemplateType: 14,
      findAnalysisItemParams: null,
      paramsChangeObj: {
        type: '',
        num: 0,
      }, // 这个根据当前页面逻辑，可用可不用，这个是当主题参数改变是重新刷新数据，跟定时更新数据不一样
    }
  },
  created() {
    if (this.currSportsDetail && this.currSportsDetail.eventId) {
      this.init()
    } else {
      console.debug(this.currSportsDetail)
    }
  },
  mounted() {},
  methods: {
    async init() {
      console.debug('this.currSportsDetail:', this.currSportsDetail)
      this.makeAnalysisItemParams(this.themeTemplateType)
    },
    makeAnalysisItemParams(themeTemplateType) {
      // 每个页面单独设置不同函数
      this.findAnalysisItemParams = {
        sportType: 'compreSportsMeet',
        templateType: themeTemplateType,
        cid: this.currCid,
        sid: this.currSid,
        did: this.currSportsDetail.sportsId
          ? this.currSportsDetail.sportsId
          : 0,
        eid: this.currSportsDetail.eventId ? this.currSportsDetail.eventId : 0,
        pid: 0,
        mid: this.currSportsDetail.matchId ? this.currSportsDetail.matchId : 0,
      }
      let { num } = this.paramsChangeObj
      this.paramsChangeObj = {
        type: 'reset',
        num: num + 1,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#compreSportsMeet_scheduleDetail_eventDataAnalysis {
  padding: 1.388vw 0 2.083vw 0;
  width: 100%;
}
</style>
